(function () {
  // ★ Step 3（Cloudflare Tunnel）で確定URLに差し替える仮の値
  const RESTOCK_API = "https://restock.phoenixjp.site/api/subscribe";

  document.querySelectorAll("[data-restock-wrapper]").forEach(initRestock);

  function initRestock(wrapper) {
    const toggle = wrapper.querySelector("[data-restock-toggle]");
    const panel = wrapper.querySelector("[data-restock-panel]");
    const emailEl = wrapper.querySelector("[data-restock-email]");
    const hpEl = wrapper.querySelector("[data-restock-hp]");
    const submit = wrapper.querySelector("[data-restock-submit]");
    const msg = wrapper.querySelector("[data-restock-msg]");

    let variants = [];
    let productInfo = { productId: null, productTitle: null };
    try {
      variants = JSON.parse(wrapper.querySelector("[data-restock-variants]").textContent);
      productInfo = JSON.parse(wrapper.querySelector("[data-restock-product]").textContent);
    } catch (e) {}

    // 現在選択中のバリアントIDを取得（Dawnの hidden input）
    function currentVariantId() {
      const form = document.querySelector('product-form input[name="id"]');
      return form ? String(form.value) : null;
    }

    function currentVariant() {
      const id = currentVariantId();
      return variants.find((v) => String(v.id) === id) || null;
    }

    // 売り切れバリアントのときだけラッパーを表示
    function refreshVisibility() {
      const v = currentVariant();
      const soldOut = v ? v.available === false : false;
      wrapper.hidden = !soldOut;
      if (!soldOut) closePanel();
    }

    function openPanel() {
      panel.hidden = false;
      hideMsg();
      emailEl && emailEl.focus();
    }
    function closePanel() {
      panel.hidden = true;
    }
    function hideMsg() {
      msg.hidden = true;
      msg.className = "restock-notify__msg";
      msg.textContent = "";
    }
    function showMsg(text, kind) {
      msg.hidden = false;
      msg.className = "restock-notify__msg " + (kind === "ok" ? "is-success" : "is-error");
      msg.textContent = text;
    }

    toggle.addEventListener("click", function () {
      if (panel.hidden) openPanel();
      else closePanel();
    });

    submit.addEventListener("click", async function () {
      const email = (emailEl.value || "").trim();
      const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRe.test(email)) {
        showMsg("メールアドレスの形式をご確認ください。", "error");
        return;
      }
      const v = currentVariant();
      if (!v) {
        showMsg("時間をおいて再度お試しください。", "error");
        return;
      }

      submit.disabled = true;
      try {
        const res = await fetch(RESTOCK_API, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: email,
            variantId: String(v.id),
            variantTitle: v.title || null,
            productId: productInfo.productId != null ? String(productInfo.productId) : null,
            productTitle: productInfo.productTitle || null,
            website: (hpEl && hpEl.value) || "" // ハニーポット
          })
        });
        const data = await res.json().catch(() => ({}));
        if (res.ok && data.ok) {
          showMsg("入荷時にお知らせします。ご登録ありがとうございます。", "ok");
          emailEl.value = "";
        } else {
          showMsg("登録できませんでした。時間をおいて再度お試しください。", "error");
        }
      } catch (e) {
        showMsg("通信エラーが発生しました。時間をおいて再度お試しください。", "error");
      } finally {
        submit.disabled = false;
      }
    });

    // 香り切替に追従（Dawnは variant:change を発火）
    document.addEventListener("variant:change", refreshVisibility);
    // フォールバック：input[name="id"] の変化も監視
    const idInput = document.querySelector('product-form input[name="id"]');
    if (idInput) {
      new MutationObserver(refreshVisibility).observe(idInput, {
        attributes: true,
        attributeFilter: ["value"]
      });
    }

    refreshVisibility();
  }
})();